module.exports = __webpack_public_path__ + "static/seller/img/gjhy.38821669.png";